const mapStateToProps = state => 
    ({
        step: state.solicitudEmpadronamientoExtranjero.step,
        stepPortalWeb: state.solicitudEmpadronamientoPortalWeb.stepPortalWeb,
        datosPortalWeb: state.solicitudEmpadronamientoPortalWeb.datosPortalWeb,
        homonimos: state.solicitudEmpadronamiento.homonimos,
        datosGeneralesDelCiudadano: state.solicitudEmpadronamientoExtranjero.datosGeneralesDelCiudadano,
        datosSolicitudExtranjero: state.solicitudEmpadronamientoExtranjero.datosSolicitudExtranjero,
    });
export default mapStateToProps;
